import { searchService } from '../services/search';
import { useTenantConfig } from '../contexts';
import { BannerEntity } from '../types';
import { logger } from '@teko/log';
import useSWR from 'swr';

export const useBanners = (zone: string) => {
  const { terminal } = useTenantConfig();

  const { data, error, isValidating } = useSWR(
    ['/banner/search', zone, terminal],
    async () => {
      return await searchService.getBannerByZone(zone, terminal);
    },
    {
      fallbackData: [] as BannerEntity[],
      onError: (e) => {
        logger.error(e, 'getBannerByZone error');
        return [];
      },
    },
  );

  return {
    banners: data || ([] as BannerEntity[]),
    loading: !zone || !terminal ? false : (!error && !data) || isValidating,
  };
};
